"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollElement = exports.IOSScrollBlockContextProvider = exports.Index = void 0;
const react_1 = require("react");
const libs_context_modals_1 = require("@hotelplan/libs.context.modals");
const libs_utils_1 = require("@hotelplan/libs.utils");
const scrollingElements = [];
const isElementScrolled = (element) => element.scrollHeight - element.scrollTop - element.clientHeight < 1;
let initialClientY = -1;
let targetElement;
let withinModals = false;
function onTouchStart(event) {
    if (event.targetTouches.length === 1) {
        targetElement = (0, libs_utils_1.findScrollableElement)(event.target, scrollingElements);
        withinModals = (0, libs_context_modals_1.withinModalsContainer)(event.target);
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
    }
}
function onTouchMove(event) {
    if (!targetElement && withinModals) {
        event.preventDefault();
        return;
    }
    if (targetElement && event.targetTouches.length === 1) {
        const clientY = event.targetTouches[0].clientY - initialClientY;
        if (targetElement.scrollTop < 1 && clientY > 0) {
            // element is at the top of its scroll.
            event.preventDefault();
        }
        else if (isElementScrolled(targetElement) && clientY < 0) {
            // element is at the bottom of its scroll.
            event.preventDefault();
        }
        else {
            event.stopPropagation();
        }
    }
}
let isListening = false;
function startListening() {
    if (isListening)
        return;
    isListening = true;
    document.body.addEventListener('touchstart', onTouchStart, {
        passive: false,
    });
    document.body.addEventListener('touchmove', onTouchMove, { passive: false });
}
function stopListening() {
    if (!isListening)
        return;
    isListening = false;
    document.body.removeEventListener('touchstart', onTouchStart);
    document.body.removeEventListener('touchmove', onTouchMove);
}
// Because of active event listeners it's better to remove them
// when nothing is scrollable within the app
function elementsAreChangedCallback() {
    if (scrollingElements.length) {
        startListening();
    }
    else {
        stopListening();
    }
}
const iOSScrollBlockContextValue = {
    addScrollElement(element) {
        element.setAttribute('scrollable', 'true');
        scrollingElements.push(element);
        elementsAreChangedCallback();
    },
    removeScrollElement(element) {
        element.removeAttribute('scrollable');
        scrollingElements.splice(scrollingElements.indexOf(element), 1);
        elementsAreChangedCallback();
    },
};
exports.Index = (0, react_1.createContext)(iOSScrollBlockContextValue);
function IOSScrollBlockContextProvider(props) {
    return (0, react_1.createElement)(exports.Index.Provider, { value: iOSScrollBlockContextValue }, props.children);
}
exports.IOSScrollBlockContextProvider = IOSScrollBlockContextProvider;
function useScrollElement(scrollElementRef, enable = true) {
    const blockScrollContext = (0, react_1.useContext)(exports.Index);
    (0, react_1.useEffect)(() => {
        if ((!libs_utils_1.isIOS && !libs_utils_1.isAndroid) || !enable || !blockScrollContext)
            return;
        const element = scrollElementRef.current;
        if (!element)
            return;
        blockScrollContext.addScrollElement(element);
        return () => {
            blockScrollContext.removeScrollElement(element);
        };
    }, [blockScrollContext, enable, scrollElementRef]);
}
exports.useScrollElement = useScrollElement;
//# sourceMappingURL=index.js.map